/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Upload_SubmitInputs */



/**
* | output |
* | --- |
* | "Upload Deck" |
*
* @param {Deck_Upload_SubmitInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_upload_submit = /** @type {((inputs?: Deck_Upload_SubmitInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Upload_SubmitInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Télécharger le Deck")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargar Deck")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Enviar Deck")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carica Deck")
	return /** @type {LocalizedString} */ ("Upload Deck")
});